import { get } from 'lodash';

const { NODE_ENV, REACT_APP_FIVE_NUMBER } = process.env;

export const removeObject = object => {
  const data = object;

  return Object.keys(data).forEach(key => {
    delete data[key];
  });
};

export const generateRandomFiveNumber = () => {
  // for running on local device
  if (NODE_ENV === 'development') return REACT_APP_FIVE_NUMBER;
  return Math.floor(Math.random() * 90000) + 10000;
};
